// extracted by mini-css-extract-plugin
export default {"hideTooltip":"q8-z","fadeIn":"r8-z","delay":"s8-z","recommendedSizeTooltip":"t8-z"};